import SanityMuxVideo from '~/components/sanity/SanityMuxVideo.vue';
import SanityImage from '~/components/sanity/SanityImage.vue';
import SanityInlineImage from '~/components/sanity/SanityInlineImage.vue';
import SanityLink from '~/components/sanity/SanityLink.vue';
import SanityColoredText from '~/components/sanity/SanityColoredText.vue';
import SanityBlockBreak from '~/components/sanity//SanityBlockBreak.vue';
export default {
  name: 'SanityBlockContent',
  props: {
    blocks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      serializers: {
        types: {
          image: SanityImage,
          muxVideo: SanityMuxVideo,
          break: SanityBlockBreak
        },
        marks: {
          link: SanityLink,
          color: SanityColoredText,
          underline: 'u',
          sup: 'sup',
          'strike-through': 'strike',
          inlineImage: SanityInlineImage
        },
        list: {
          bullet: 'ul',
          number: 'ol'
        }
      }
    };
  }
};